"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const forms_1 = require("@/forms");
const services_1 = require("@/helpers/services");
const redux_1 = require("@/redux");
const selectors_1 = __importDefault(require("@/selectors"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const ManageAccountsCreateScreen = ({ pendingPrograms, pendingCaregivers, pendingUserCreate, adminPrograms, caregivers, listPrograms, listCaregivers, }) => {
    react_1.useEffect(() => {
        listPrograms();
        listCaregivers();
    }, []);
    if (pendingPrograms || pendingCaregivers)
        return react_1.default.createElement(components_1.ScreenLoader, null);
    return (react_1.default.createElement("div", { className: styles_scss_1.default.manageAccountsCreate },
        pendingUserCreate && (react_1.default.createElement(components_1.SaveLoader, { title: constants_1.default.manageAccounts.create.savingAccount, description: constants_1.default.general.pleaseDontClose })),
        react_1.default.createElement(components_1.Meta, { title: constants_1.default.manageAccounts.create.helmetTitle, removeViewport: true }),
        react_1.default.createElement(components_1.Paper, { className: styles_scss_1.default.contentPaper },
            react_1.default.createElement(components_1.Link, { to: constants_1.Routes.ManageAccounts },
                react_1.default.createElement(components_1.Button, { className: styles_scss_1.default.goBackButton, variant: "transparent", title: constants_1.default.manageAccounts.create.backToAccounts, ariaLabel: constants_1.default.manageAccounts.create.backToAccounts, imgUrls: { default: constants_1.Images.arrowLeftGreen, selected: constants_1.Images.arrowLeftGreen } })),
            react_1.default.createElement("div", { className: styles_scss_1.default.headerCont },
                react_1.default.createElement("div", { className: styles_scss_1.default.headerLeftCont },
                    react_1.default.createElement("h2", null, constants_1.default.manageAccounts.create.pageTitle))),
            react_1.default.createElement("div", { className: styles_scss_1.default.formCont },
                react_1.default.createElement(forms_1.AccountCreateForm, { programs: adminPrograms, caregivers: caregivers })))));
};
const mapStateToProps = (state) => ({
    adminPrograms: selectors_1.default.program.getAdminPrograms(state),
    pendingPrograms: selectors_1.default.program.getPendingAdminPrograms(state),
    caregivers: selectors_1.default.user.getCaregivers(state),
    pendingCaregivers: selectors_1.default.user.getPendingCaregivers(state),
    pendingUserCreate: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.createUser),
});
const mapDispatchToProps = {
    listPrograms: () => redux_1.ActionCreators.program.listProgramsRequest.dispatch(),
    listCaregivers: () => redux_1.ActionCreators.user.listCaregiversRequest.dispatch(),
};
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ManageAccountsCreateScreen));
